(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'FranchiseTaxInfoChangeAddress',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// monitor address changes
		$('.monitor-changes').on('keyup change', function click(e)
		{
			var $self   = $(this),
			    origVal = $self.data('original'),
			    newVal  = $self.val();

			if (origVal === newVal) {
				$('#franchisetaxinfochangeaddress-franchise_tax_info-address_changed').val('0');
				$('#address_change_warning').addClass('hidden');
			} else {
				$('#franchisetaxinfochangeaddress-franchise_tax_info-address_changed').val('1');
				$('#address_change_warning').removeClass('hidden');
			}
		});
	};
}(jQuery, window.Adzuki || {}));
